const getSurvoyorList = (state, payload) => {
  state.survoyorList = payload.data;
}


export default {
  getSurvoyorList,
}


// WEBPACK FOOTER //
// ./src/store/modules/survoyor/mutations.js